module.exports = __webpack_public_path__ + "static/33F324_A_0-7810e786f22462e11024b330775e6d5b.ttf";